const HOST_SELECTOR = '.ui.menu.tabular';
const INDICATOR_CLASS = 'tabular-menu-indicator';

function getIndicator(container) {
    let indicator = container.querySelector(`:scope > .${INDICATOR_CLASS}`);
    if (!indicator) {
        indicator = document.createElement('div');
        indicator.className = INDICATOR_CLASS;
        container.insertBefore(indicator, container.firstChild);
    }
    return indicator;
}

function positionIndicator(menu) {
    // Certains menus enveloppent leurs .item dans un conteneur intermédiaire (ex. scroll horizontal
    // avec un bouton hors-scroll) : on cherche donc l'item actif à toute profondeur, tout en excluant
    // ceux appartenant à un menu tabulaire imbriqué plus profond.
    const active = Array.from(menu.querySelectorAll('.item.active')).find(item => item.closest(HOST_SELECTOR) === menu);
    if (!active) { menu.querySelectorAll(`.${INDICATOR_CLASS}`).forEach(ind => ind.style.opacity = '0'); return; }

    // L'indicateur doit vivre dans le même conteneur direct que les .item (pas forcément `menu` lui-même)
    // pour hériter de son scroll horizontal et de son clipping — sinon il se décale ou déborde hors barre
    // quand les items sont dans un wrapper scrollable distinct du menu (ex. bouton "+" hors-scroll).
    const container = active.parentElement;
    if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
    menu.querySelectorAll(`.${INDICATOR_CLASS}`).forEach(ind => { if (ind.parentElement !== container) ind.remove(); });

    const indicator = getIndicator(container);
    indicator.style.opacity = '1';
    indicator.style.top = `${active.offsetTop}px`;
    indicator.style.left = `${active.offsetLeft}px`;
    indicator.style.width = `${active.offsetWidth}px`;
    indicator.style.height = `${active.offsetHeight}px`;
}

function scan() {
    document.querySelectorAll(HOST_SELECTOR).forEach(positionIndicator);
}

let debounceTimer = null;
function scheduleScan() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(scan, 120);
}

// Repositionne l'indicateur (le bloc vert glissant) de tous les Semantic UI <Menu tabular> de l'app,
// sans devoir instrumenter chaque composant individuellement (une trentaine d'usages dans le code).
export function initTabularMenuIndicator() {
    scan();

    document.addEventListener('click', (e) => {
        const menu = e.target.closest(HOST_SELECTOR);
        if (menu) requestAnimationFrame(() => positionIndicator(menu));
    }, true);

    window.addEventListener('resize', scheduleScan);

    new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
}
